import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import ModalFullscreen from '../../../ModalFullscreen';
import FullscreenModalHeader from '../../../BaseComponents/Header/components/FullscreenModalHeader';

interface Props {
	isOpen: boolean;
	isSelected?: boolean;
	onClose: () => void;
}

const DesktopFlightFullscreen: React.FunctionComponent<Props> = ({ isOpen, onClose, isSelected, children }) => {
	const { DesktopFlightFullscreen: css } = useTheme('DesktopFlight');

	const { t } = useTranslation('FlightInfoModalContent');

	const title = t(isSelected ? 'You choose' : 'Select your bundle');

	return (
		<ModalFullscreen
			className={css.modalFullscreen__content}
			classes={{
				root: css.modalFullscreen__root,
				header: css.modalFullscreen__header
			}}
			keepMounted={false}
			isOpen={isOpen}
			onClose={onClose}
			enableSwipeToClose={false}
			title={
				<FullscreenModalHeader
					title={title}
					onClose={onClose}
					onClickBackward={onClose}
					className={css.modalFullscreen__fixed}
				/>
			}
		>
			{children}
		</ModalFullscreen>
	);
};

export default DesktopFlightFullscreen;
